import { List, Stack, StackProps } from "@mui/material";
import { Home, BugReport } from "@mui/icons-material";
import { DrawerNavMenuItem } from "./DrawerNavMenuItem";
import { LabNavMenuItems } from "./LabNavMenuItems";
import { useAuth } from "src/utils/useAuth";

/**
 * Navigation menu with all app routes.
 *
 * Customize this to add your own navigation items.
 */
export function DrawerNavMenu(props: Omit<StackProps, "children"> & { collapsed?: boolean }) {
  const { collapsed, ...stackProps } = props;
  const { isEnabled } = useAuth();

  return (
    <Stack justifyContent="space-between" flexGrow={1} width="100%" {...stackProps}>
      <Stack spacing={0}>
        {/* Primary Navigation */}
        <List disablePadding>
          <DrawerNavMenuItem
            icon={<Home />}
            label="Home"
            tooltip="Home"
            path="/"
            collapsed={collapsed}
          />
        </List>

        {/* Labs Navigation - Dynamic */}
        <LabNavMenuItems collapsed={collapsed} />
      </Stack>

      {/* Secondary Navigation */}
      {isEnabled && (
        <List disablePadding>
          <DrawerNavMenuItem
            icon={<BugReport />}
            label="JWT Debug"
            tooltip="JWT Debug"
            path="/debug"
            collapsed={collapsed}
          />
        </List>
      )}
    </Stack>
  );
}
